import { render, staticRenderFns } from "./emailLogin.vue?vue&type=template&id=49858d7f&scoped=true"
import script from "./emailLogin.vue?vue&type=script&lang=js"
export * from "./emailLogin.vue?vue&type=script&lang=js"
import style0 from "./emailLogin.vue?vue&type=style&index=0&id=49858d7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49858d7f",
  null
  
)

export default component.exports